import { cn } from '../../lib/utils';

/**
 * Spinner - Lucky Number Design System
 *
 * Loading indicator with electric or accent variants.
 */

const sizes = {
  sm: 'w-4 h-4',
  md: 'w-6 h-6',
  lg: 'w-8 h-8',
};

export default function Spinner({
  size = 'md',
  variant = 'default', // 'default' | 'accent' | 'dark'
  className
}) {
  const colors = {
    default: 'text-electric',
    accent: 'text-accent',
    dark: 'text-midnight',
  };

  return (
    <svg
      className={cn('animate-spin', sizes[size], colors[variant], className)}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle
        className="opacity-25"
        cx="12"
        cy="12"
        r="10"
        stroke="currentColor"
        strokeWidth="4"
      />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      />
    </svg>
  );
}

/**
 * LoadingDots - animated dots for loading states
 */
export function LoadingDots({ className }) {
  return (
    <span className={cn('inline-flex items-center gap-1', className)}>
      {[0, 1, 2].map((i) => (
        <span
          key={i}
          className="w-1.5 h-1.5 rounded-full bg-current animate-bounce"
          style={{ animationDelay: `${i * 0.15}s` }}
        />
      ))}
    </span>
  );
}

/**
 * FullPageSpinner - centered spinner for page loading
 */
export function FullPageSpinner({ message }) {
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center">
      <Spinner size="lg" variant="accent" />
      {message && (
        <p className="mt-4 text-cream/60 text-sm">{message}</p>
      )}
    </div>
  );
}

/**
 * AccentSpinner - special accent spinner for processing/winner moments
 */
export function AccentSpinner({ size = 'lg', className }) {
  return (
    <div className={cn('relative', className)}>
      <Spinner size={size} variant="accent" />
      <div className="absolute inset-0 animate-accent-pulse rounded-full" />
    </div>
  );
}
